// import * as vuex from '@/api/vuex.api'
import base from '@/api/base';

export default {
  // vuex,
  ...base,
};



// WEBPACK FOOTER //
// ./src/api/index.js